import api from "@/services/api";
import type {
	Fence,
	FenceFormData,
	FenceParams,
	PaginatedFencesResponse,
} from "../types/fence";

export const fenceService = {
	async getFences(params?: FenceParams): Promise<PaginatedFencesResponse> {
		const { data } = await api.get<PaginatedFencesResponse>("/api/fence", {
			params: {
				pageNumber: params?.pageNumber ?? 1,
				pageSize: params?.pageSize ?? 10,
				sortBy: params?.sortBy,
				sortDirection: params?.sortDirection,
				search: params?.search,
			},
		});
		return data;
	},

	async getFenceById(id: number): Promise<Fence> {
		const { data } = await api.get<Fence>(`/api/fence/${id}`);
		return data;
	},

	async createFence(fenceData: FenceFormData): Promise<Fence> {
		const { data } = await api.post<Fence>("/api/fence", fenceData);
		return data;
	},

	async updateFence(id: number, fenceData: FenceFormData): Promise<Fence> {
		const { data } = await api.put<Fence>(`/api/fence/${id}`, fenceData);
		return data;
	},

	async deleteFence(id: number): Promise<void> {
		await api.delete(`/api/fence/${id}`);
	},
};
